import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Copy, Code } from "lucide-react";
import DOMPurify from "dompurify";
import api, { fileUrl } from "@/lib/api";
import DashboardLayout from "@/components/DashboardLayout";

export default function EmailSignature() {
  const [cards, setCards] = useState([]);
  const [card, setCard] = useState(null);

  useEffect(() => { api.get("/cards").then((r) => { setCards(r.data); if (r.data[0]) setCard(r.data[0]); }); }, []);

  const cardUrl = card ? `${window.location.origin}/c/${card.slug}` : "";
  const gold = card?.brand_color || "#D4AF37";

  const html = card ? `<table cellpadding="0" cellspacing="0" style="font-family:Arial,sans-serif;color:#081426;">
  <tr>
    ${card.avatar_url ? `<td style="padding-right:16px;"><img src="${fileUrl(card.avatar_url)}" width="72" height="72" style="border-radius:10px;object-fit:cover;" /></td>` : ""}
    <td style="border-left:3px solid ${gold};padding-left:16px;">
      <div style="font-size:17px;font-weight:bold;">${card.full_name || ""}</div>
      <div style="font-size:13px;color:${gold};font-weight:bold;">${card.job_title || ""}${card.company ? " · " + card.company : ""}</div>
      <div style="font-size:12px;color:#555;margin-top:6px;">
        ${card.phone ? `📞 ${card.phone} &nbsp;` : ""}${card.email ? `✉️ ${card.email}` : ""}
      </div>
      <a href="${cardUrl}" style="display:inline-block;margin-top:8px;font-size:12px;background:${gold};color:#081426;padding:6px 14px;border-radius:20px;text-decoration:none;font-weight:bold;">View my digital card</a>
    </td>
  </tr>
</table>` : "";

  const copyHtml = () => { navigator.clipboard.writeText(html); toast.success("Signature HTML copied — paste into Gmail/Outlook"); };

  return (
    <DashboardLayout title="Email Signature">
      {cards.length === 0 ? (
        <div className="iw-card p-12 text-center"><p className="text-[#8B9BB4]">Create a card first to generate an email signature.</p></div>
      ) : (
        <div className="space-y-6 fade-up">
          <div className="iw-card p-6 max-w-md">
            <label className="text-xs text-[#8B9BB4] font-semibold mb-1.5 block">Select card</label>
            <select className="iw-input" value={card?.id || ""} onChange={(e) => setCard(cards.find((c) => c.id === e.target.value))} data-testid="sig-card-select">
              {cards.map((c) => <option key={c.id} value={c.id}>{c.full_name || c.slug}</option>)}
            </select>
          </div>

          <div className="iw-card p-8">
            <p className="overline mb-4">Preview</p>
            <div className="bg-white rounded-xl p-6" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html) }} data-testid="sig-preview" />
          </div>

          <div className="iw-card p-6">
            <div className="flex items-center justify-between mb-3">
              <p className="overline flex items-center gap-2"><Code size={14} /> HTML Source</p>
              <button onClick={copyHtml} className="btn-gold px-4 py-2 rounded-full text-xs flex items-center gap-2" data-testid="copy-sig-btn"><Copy size={13} /> Copy HTML</button>
            </div>
            <pre className="text-xs text-[#8B9BB4] bg-[#081426] rounded-lg p-4 overflow-x-auto whitespace-pre-wrap break-all">{html}</pre>
          </div>
        </div>
      )}
    </DashboardLayout>
  );
}
